import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PDFService } from '../../services/pdf.service';
import { ConnectionService } from '../../services/connection.service';

export interface DialogData {
    PDFTemplate: string;
    data: any;
}

@Component({
    selector: 'app-pdf',
    templateUrl: './pdf.dialog.html',
    styleUrls: ['./pdf.dialog.scss', '../common-dialog-styles.scss']
})
export class PDFDialogComponent {

    htmlSrc: string = null;
    pdfSrcView: string = null;
    pdfSrcDownload: string = null;
    src: string = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private connectionService: ConnectionService,
        private pdfService: PDFService) {
        this.pdfService.check(this.data.PDFTemplate, this.data).subscribe((result: any) => {
            if (result.hash == null) {
                this.generatePDF(this.data.PDFTemplate, this.data.data);
            } else {
                this.src = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&i=" + Date.now();

                this.htmlSrc = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
                this.pdfSrcView = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&i=" + Date.now();
                this.pdfSrcDownload = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&filename=downloaded&i=" + Date.now()
            }
        })
    }

    generatePDF(PDFTemplate: string, data: any) {
        this.src = null;

        this.pdfService.generatePDF2(PDFTemplate, data).subscribe((result: any) => {
            console.log(result);
            this.src = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&i=" + Date.now();
            this.htmlSrc = this.connectionService.address + "/templates/pdfs/" + result.hash + "/index.html";
            this.pdfSrcView = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&i=" + Date.now();
            this.pdfSrcDownload = this.connectionService.address + "/pdf-service/view?file=" + result.hash + "&filename=downloaded&i=" + Date.now()

            
        })
    }


    downloadPDF() {
        let filename = "download-pdf";

        this.pdfService.download(this.data.PDFTemplate, this.data.data, filename);
    }

    viewPDF() {
        this.pdfService.view(this.data.PDFTemplate, this.data.data);
    }

    printPDF() {
        this.pdfService.print(this.data.PDFTemplate, this.data.data);
    }

    reloadPDF() {
        this.src = null;
        this.generatePDF(this.data.PDFTemplate, this.data.data);
      }
}